// Static content ported from the original Renaître mobile app.

export const ILLUSTRATIONS = [
  { src: "/illustrations/mom-african.jpg", origin: "Afrique" },
  { src: "/illustrations/mom-arab.jpg", origin: "Maghreb" },
  { src: "/illustrations/mom-asian.jpg", origin: "Asie de l'Est" },
  { src: "/illustrations/mom-european.jpg", origin: "Europe" },
  { src: "/illustrations/mom-mixed.jpg", origin: "Métisse" },
  { src: "/illustrations/mom-southasian.jpg", origin: "Asie du Sud" },
];

export const AVATAR_DEFAULT = "/illustrations/avatar-default.jpg";

export const HERO_IMAGES = ILLUSTRATIONS.map((i) => i.src);

export function heroImageOfDay(offset = 0) {
  const day = Math.floor(Date.now() / 86400000);
  return HERO_IMAGES[(day + offset) % HERO_IMAGES.length];
}

export const DAILY_MESSAGES = [
  "Vous faites de votre mieux, et c'est déjà beaucoup.",
  "Un jour à la fois. Vous n'avez rien à prouver.",
  "Votre douceur d'aujourd'hui est un cadeau pour vous deux.",
  "Se reposer n'est pas abandonner. C'est prendre soin.",
  "Vous apprenez, et c'est exactement ce qu'il faut.",
  "Chaque câlin compte plus que la perfection.",
  "Il n'y a pas de maman parfaite, seulement des mamans aimantes.",
  "Respirez. Ce moment aussi va passer, en douceur.",
  "Vous êtes la personne dont votre bébé a le plus besoin.",
  "Vos émotions sont légitimes. Accueillez-les sans juger.",
  "Demander de l'aide est une preuve de force.",
  "Aujourd'hui, offrez-vous un peu de la tendresse que vous donnez.",
  "Votre corps a accompli quelque chose d'immense. Merci à lui.",
  "Les petits pas sont aussi de grandes victoires.",
];

export function dailyMessageOfDay() {
  const day = Math.floor(Date.now() / 86400000);
  return DAILY_MESSAGES[day % DAILY_MESSAGES.length];
}

// Gentle weather metaphor for feelings.
export const MOODS = [
  { value: 1, label: "Très dur", icon: "CloudLightning", color: "#B56A63" },
  { value: 2, label: "Difficile", icon: "CloudRain", color: "#C57B67" },
  { value: 3, label: "Mitigée", icon: "Cloud", color: "#B5B1A6" },
  { value: 4, label: "Douce", icon: "Sun", color: "#88A096" },
  { value: 5, label: "Rayonnante", icon: "Heart", color: "#D8A7A7" },
];
export const moodByValue = (v) => MOODS.find((m) => m.value === v);

export const TESTIMONIALS = [
  { quote: "Certains jours, juste tenir jusqu'au soir était une victoire. Cette app m'a rappelé que c'était déjà énorme.", author: "Léa, maman de Jules" },
  { quote: "Noter mon humeur chaque matin m'a aidée à comprendre mes émotions au lieu de les subir.", author: "Fatou, maman de Aya" },
  { quote: "J'ai appris à demander de l'aide. Ce n'était pas une faiblesse, c'était de l'amour pour nous deux.", author: "Marion, maman de Noé" },
  { quote: "Les nuits étaient dures, mais lire que c'était normal m'a enlevé un poids immense.", author: "Inès, maman de Sofia" },
  { quote: "Personne ne m'avait dit que le lien pouvait mettre du temps. Aujourd'hui, on est inséparables.", author: "Chloé, maman de Gabriel" },
  { quote: "Prendre 5 minutes pour respirer, rien que pour moi, a tout changé dans mes journées.", author: "Sarah, maman de Lina" },
];

// EPDS — Échelle d'Édimbourg
export const EPDS_QUESTIONS = [
  { id: 1, text: "J'ai pu rire et prendre les choses du bon côté :", options: [["Aussi souvent que d'habitude", 0], ["Pas tout à fait autant", 1], ["Vraiment moins que d'habitude", 2], ["Plus du tout", 3]] },
  { id: 2, text: "Je me suis réjouie à l'idée de faire des choses :", options: [["Autant que d'habitude", 0], ["Plutôt moins qu'avant", 1], ["Beaucoup moins qu'avant", 2], ["Presque jamais", 3]] },
  { id: 3, text: "Je me suis reproché, sans raison, d'être responsable quand les choses allaient mal :", options: [["Oui, la plupart du temps", 3], ["Oui, parfois", 2], ["Pas très souvent", 1], ["Non, jamais", 0]] },
  { id: 4, text: "Je me suis sentie inquiète ou soucieuse sans motif :", options: [["Non, pas du tout", 0], ["Presque jamais", 1], ["Oui, parfois", 2], ["Oui, très souvent", 3]] },
  { id: 5, text: "Je me suis sentie effrayée ou paniquée sans vraiment de raison :", options: [["Oui, vraiment souvent", 3], ["Oui, parfois", 2], ["Non, pas très souvent", 1], ["Non, pas du tout", 0]] },
  { id: 6, text: "J'ai eu tendance à me sentir dépassée par les événements :", options: [["Oui, la plupart du temps je n'ai pas pu y faire face", 3], ["Oui, parfois je n'ai pas pu faire face aussi bien", 2], ["Non, j'ai pu faire face à la plupart des situations", 1], ["Non, j'ai pu faire face aussi bien que d'habitude", 0]] },
  { id: 7, text: "Je me suis sentie si malheureuse que j'ai eu des difficultés à dormir :", options: [["Oui, la plupart du temps", 3], ["Oui, parfois", 2], ["Pas très souvent", 1], ["Non, pas du tout", 0]] },
  { id: 8, text: "Je me suis sentie triste ou peu heureuse :", options: [["Oui, la plupart du temps", 3], ["Oui, très souvent", 2], ["Pas très souvent", 1], ["Non, pas du tout", 0]] },
  { id: 9, text: "Je me suis sentie si malheureuse que j'en ai pleuré :", options: [["Oui, la plupart du temps", 3], ["Oui, très souvent", 2], ["Seulement de temps en temps", 1], ["Non, jamais", 0]] },
  { id: 10, text: "Il m'est arrivé de penser à me faire du mal :", options: [["Oui, très souvent", 3], ["Parfois", 2], ["Presque jamais", 1], ["Jamais", 0]] },
];

export const EPDS_THRESHOLD = 12;

export function zoneForScore(score) {
  if (score >= EPDS_THRESHOLD) return "difficile";
  if (score >= 9) return "mitige";
  return "doux";
}

export const EPDS_ZONE_META = {
  doux: { label: "Doux", color: "#9CAEA9", message: "Vos réponses évoquent un moment plutôt doux. Continuez à prendre soin de vous, un jour à la fois." },
  mitige: { label: "Mitigé", color: "#D3B683", message: "Certaines journées semblent plus lourdes. C'est normal. En parler à une sage-femme ou un médecin peut faire du bien." },
  difficile: { label: "Difficile", color: "#C57B67", message: "Vos réponses montrent que cette période est difficile. Vous n'êtes pas seule : un professionnel peut vous accompagner. Parlez-en dès que possible." },
};

export function evaluateEpds(answers) {
  const score = answers.reduce((a, b) => a + (b || 0), 0);
  const selfHarm = (answers[9] ?? 0) > 0;
  const atRisk = score >= EPDS_THRESHOLD || selfHarm;
  return { score, atRisk, selfHarm, zone: zoneForScore(score) };
}

// Meditation & breathing sessions (public-domain audio).
const PIANO_SOFT = "https://upload.wikimedia.org/wikipedia/commons/6/6c/Piano_Between_%28ISRC_USUAN1100490%29.mp3";
const PIANO_SATIE = "https://upload.wikimedia.org/wikipedia/commons/2/20/Gymnopedie_No._2_%28ISRC_USUAN1100786%29.mp3";
const PIANO_AMBIENT = "https://upload.wikimedia.org/wikipedia/commons/c/cd/Dreams_Become_Real_%28ISRC_USUAN1500027%29.mp3";
const NATURE_RAIN_FOREST = "https://upload.wikimedia.org/wikipedia/commons/2/24/Bourne_woods_Birdsong_and_rain_2020-06-17_0742.mp3";
const NATURE_WAVES = "https://upload.wikimedia.org/wikipedia/commons/transcoded/f/f1/Oceanwavescrushing.ogg/Oceanwavescrushing.ogg.mp3";

export const MEDITATIONS = [
  { id: "coherence-cardiaque", title: "Cohérence cardiaque guidée", subtitle: "Apaiser le rythme, en 5 minutes", duration: "5 min", gradient: ["#9CAEA9", "#88A096"], icon: "Heart", audio: PIANO_SOFT },
  { id: "respiration", title: "Respiration apaisante", subtitle: "Retrouver son souffle en douceur", duration: "5 min", gradient: ["#D8A7A7", "#C57B67"], icon: "Wind", audio: PIANO_SOFT },
  { id: "respiration-478", title: "Respiration 4-7-8", subtitle: "Pour s'endormir en douceur", duration: "6 min", gradient: ["#B7C4BE", "#9CAEA9"], icon: "Moon", audio: PIANO_AMBIENT },
  { id: "scan-corporel", title: "Scan corporel", subtitle: "Relâcher les tensions du corps", duration: "8 min", gradient: ["#D3B683", "#C57B67"], icon: "Feather", audio: PIANO_SATIE },
  { id: "visualisation", title: "Visualisation positive", subtitle: "Imaginer une journée douce", duration: "7 min", gradient: ["#E0C2A2", "#D3B683"], icon: "Sun", audio: PIANO_AMBIENT },
  { id: "lacher-prise", title: "Lâcher prise sur la culpabilité", subtitle: "Se pardonner, en douceur", duration: "9 min", gradient: ["#D8A7A7", "#C9A0A0"], icon: "Cloud", audio: PIANO_SATIE },
  { id: "piano-doux", title: "Piano doux (Satie)", subtitle: "Piano solo pour s'apaiser", duration: "6 min", gradient: ["#C9B7D4", "#B7A0C4"], icon: "MusicNote", audio: PIANO_SATIE },
  { id: "pluie-foret", title: "Pluie & forêt", subtitle: "Sons de la nature au petit matin", duration: "15 min", gradient: ["#9CAEA9", "#7E9188"], icon: "CloudRain", audio: NATURE_RAIN_FOREST },
  { id: "vagues", title: "Vagues de l'océan", subtitle: "Le va-et-vient apaisant des vagues", duration: "15 min", gradient: ["#8FB8C9", "#6E9CB0"], icon: "Drop", audio: NATURE_WAVES },
];

// Support messages after logging a mood.
export const SUPPORT_MESSAGES = {
  reconfort: [
    "Ce que tu traverses est difficile, et pourtant tu es là. C'est une force immense.",
    "Tu n'as pas à être parfaite. Être présente pour ton bébé, c'est déjà tout donner.",
    "Les jours sombres passent. Sois aussi douce avec toi que tu l'es avec ton tout-petit.",
    "Pleurer n'est pas un échec. C'est ton corps qui relâche. Autorise-toi ce moment.",
    "Respire. Une minute à la fois. Tu n'es pas seule dans cette traversée.",
    "Pose-toi une main sur le cœur. Là, tout de suite : tu es assez, telle que tu es.",
  ],
  equilibre: [
    "Un jour après l'autre, tu construis quelque chose de beau. Continue à ton rythme.",
    "Il n'y a pas de journée parfaite, juste des petits pas. Et tu avances vraiment.",
    "Prendre soin de toi fait partie de prendre soin de lui. Accorde-toi une petite douceur.",
    "Chaque câlin, chaque regard compte plus que tu ne l'imagines.",
    "Regarde le chemin déjà parcouru. Tout doucement, tu fleuris.",
  ],
  joie: [
    "Quel bonheur de te sentir rayonnante ! Savoure pleinement ce moment.",
    "Ta lumière d'aujourd'hui, ton bébé la ressent. Célèbre-la !",
    "Ces instants de joie sont précieux. Garde-les tout près de ton cœur.",
    "Ton bonheur est contagieux. Ton bébé grandit dans ta joie.",
    "Garde précieusement ce sourire d'aujourd'hui. Il te ressemble.",
  ],
};

export function supportForMood(mood) {
  const bucket = mood <= 2 ? "reconfort" : mood <= 4 ? "equilibre" : "joie";
  const list = SUPPORT_MESSAGES[bucket];
  return list[Math.floor(Math.random() * list.length)];
}

// Professionals for the "Aide" screen.
export const PROS = [
  { title: "Sage-femme libérale", role: "Assure le suivi post-natal, la rééducation du périnée, l'accompagnement à l'allaitement et à la parentalité. Consultations remboursées.", icon: "User" },
  { title: "PMI — Protection Maternelle et Infantile", role: "Consultations gratuites pour vous et bébé (pesée, conseils, vaccins), y compris un soutien psychologique et social, près de chez vous.", icon: "House" },
  { title: "Psychologue périnatal", role: "Accompagne les émotions du post-partum : baby-blues, anxiété, difficultés du lien. Un espace d'écoute sans jugement.", icon: "Heart" },
  { title: "Médecin traitant / gynécologue", role: "Point d'entrée pour tout symptôme physique ou moral persistant. Il peut vous orienter vers le bon spécialiste.", icon: "PlusCircle" },
];

// Baby age label from ISO date.
export function babyAgeLabel(iso) {
  if (!iso) return null;
  const parts = iso.split("-").map(Number);
  if (parts.length !== 3 || parts.some((n) => isNaN(n))) return null;
  const [y, m, d] = parts;
  const birth = new Date(y, m - 1, d);
  const now = new Date();
  if (isNaN(birth.getTime()) || birth > now) return null;
  const diffDays = Math.floor((now.getTime() - birth.getTime()) / 86400000);
  if (diffDays <= 15) return `Vous êtes à J+${diffDays}`;
  if (diffDays < 61) return `Bébé a ${Math.floor(diffDays / 7)} semaines`;
  let months = (now.getFullYear() - birth.getFullYear()) * 12 + (now.getMonth() - birth.getMonth());
  if (now.getDate() < birth.getDate()) months -= 1;
  if (months < 24) return `Bébé a ${months} mois`;
  const yrs = Math.floor(months / 12);
  const rem = months % 12;
  return rem ? `Bébé a ${yrs} an${yrs > 1 ? "s" : ""} et ${rem} mois` : `Bébé a ${yrs} an${yrs > 1 ? "s" : ""}`;
}

export const BIRTH_TERMS = [
  { label: "Né à terme", weeks: 39 },
  { label: "34-36 SA", weeks: 35 },
  { label: "32-33 SA", weeks: 32 },
  { label: "Avant 32 SA", weeks: 30 },
];

// Privacy / legal content
export const EDITEUR = {
  nom: "Stella Meteau",
  adresse: "20 avenue du Général Leclerc",
  cpVille: "78230 Le Pecq, France",
  email: "contact@renaitreapp.com",
  siret: "SIRET en cours d'immatriculation",
};

export const HEBERGEUR = {
  nom: "Emergent Labs Inc.",
  adresse: "2380 Via Espada, Pleasanton, California 94566, États-Unis",
  contact: "support@emergent.sh",
};

export const PRIVACY_SECTIONS = [
  { title: "Vos données d'humeur restent chez vous", body: "Les données d'humeur sont stockées exclusivement sur votre appareil (dans le navigateur). Renaître n'y a pas accès. Elles ne sont jamais transmises à un serveur, ni analysées par un tiers." },
  { title: "Vos résultats du test d'Édimbourg (EPDS)", body: "Le test d'Édimbourg est un dépistage sensible. Vos résultats EPDS sont stockés exclusivement sur votre appareil. Renaître n'y a pas accès. Ils bénéficient des mêmes protections que vos humeurs : consentement explicite et effacement en un clic." },
  { title: "Le terme de naissance de bébé", body: "Le terme de naissance (âge gestationnel) que vous pouvez renseigner est également une donnée de santé. Il est stocké uniquement sur votre appareil et n'est jamais transmis. Il sert seulement à adapter, en local, l'affichage de l'espace « Naissance prématurée »." },
  { title: "Consentement explicite", body: "Au premier lancement, votre consentement vous est demandé, séparément des conditions générales. Vous restez libre de l'accepter ou non, et de changer d'avis à tout moment." },
  { title: "Suppression en un clic", body: "Vous pouvez effacer l'intégralité de vos données à tout moment depuis votre profil, en une seule action (RGPD Article 17). La désinstallation ou l'effacement des données du navigateur supprime également l'ensemble de vos données locales." },
  { title: "Données de santé (RGPD Article 9)", body: "Les humeurs sont considérées comme des données de santé. Conformément au RGPD (Article 9) et aux recommandations de la CNIL, elles ne quittent jamais votre appareil." },
  { title: "Transfert de données non sensibles (États-Unis / Inde)", body: "Certaines données techniques non sensibles peuvent être hébergées par Emergent Labs Inc. (États-Unis et Inde). Ces transferts sont encadrés par les clauses contractuelles types approuvées par la Commission Européenne. Les données de santé (humeurs, résultats EPDS, terme de naissance) restent exclusivement sur votre appareil et ne transitent jamais par ces serveurs." },
];
